import {
  BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT,
  CLOSE_LA,
  LOGIN_FROM_LA,
  REDIRECT_FROM_LA,
  SHOW_LA
} from 'store/ducks/loginAssistant/types';

export const fetchLoginAssistantContent = () => ({ type: BEGIN_FETCH_LOGIN_ASSISTANT_CONTENT });

export const onCloseLoginAssistantClick = buttonType => ({ type: CLOSE_LA, buttonType });
export const onLoginFromLoginAssistantClick = (buttonType, redirectPath) => ({ type: LOGIN_FROM_LA, buttonType, redirectPath });
export const onRedirectFromLoginAssistantClick = (buttonType, redirectPath) => ({ type: REDIRECT_FROM_LA, buttonType, redirectPath });
export const onShowLoginAssistant = () => ({ type: SHOW_LA });
